/**
 * @generated SignedSource<<17c578efa093290e58cbfa8c6829261a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueTableGroupByDropdown_GroupByDropdown$data = {
  readonly id: string;
  readonly viewSettings: {
    readonly groupByConfig: {
      readonly groupByField: {
        readonly name: string | null | undefined;
      } | null | undefined;
    };
  };
  readonly " $fragmentType": "ui_issueTableGroupByDropdown_GroupByDropdown";
};
export type ui_issueTableGroupByDropdown_GroupByDropdown$key = {
  readonly " $data"?: ui_issueTableGroupByDropdown_GroupByDropdown$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableGroupByDropdown_GroupByDropdown">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueTableGroupByDropdown_GroupByDropdown",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraIssueSearchViewConfigSettings",
        "kind": "LinkedField",
        "name": "viewSettings",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraSpreadsheetGroupByConfig",
              "kind": "LinkedField",
              "name": "groupByConfig",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraField",
                  "kind": "LinkedField",
                  "name": "groupByField",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "viewSettings.groupByConfig"
          }
        ]
      },
      "action": "THROW",
      "path": "viewSettings"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "5221b287b6a533f3071935c5eb494b33";

export default node;
